import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=5a43e18a&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=5a43e18a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a43e18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a43e18a')) {
      api.createRecord('5a43e18a', component.options)
    } else {
      api.reload('5a43e18a', component.options)
    }
    module.hot.accept("./index2.vue?vue&type=template&id=5a43e18a&scoped=true", function () {
      api.rerender('5a43e18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tenant/index2.vue"
export default component.exports